export default __webpack_public_path__ + "static/media/icons8-linkedin-2.524f8b6e.svg";